export default class Achievements {
    constructor(data) {
        this.allAchievements = data || AchievementData;
        this.onNewAchievement = function () { };
    }
    awardAchivement(user, achievementName) {
        if (!user.achievements) user.achievements = [];
        const userHasAchievement = user.achievements.indexOf(achievementName) !== -1;
        if (userHasAchievement) return;

        let achievement = this.getAchievement(achievementName);
        if (!achievement) achievement = {
            name: achievementName,
            category: "",
            title: achievementName,
            description: "",
            points: "25"
        };

        //create acheiement if none exisit
        if (!achievement) achievement = {
            name: achievementName,
            points: 0,
            item: null,
        }

        let points = achievement.points;
        let item = achievement.item;
        //award achievement
        user.achievements.push(achievement.name);
        //award coins
        if (points)
            user.coins = (Number(user.coins) || 0) + Number(points);
        //award item
        if (item) {
            if (!user.items.includes(item)) {
                user.items.push(item);
            }
        }
        if (this.onNewAchievement) {
            this.onNewAchievement([achievement]);
        }

    }
    checkForAchievementAndReward(user, stats) {
        if (!user.achievements) user.achievements = [];
        if (!user.items) user.items = [];
        if (!stats) stats = user || {};

        let achievements = this.checkForAchievement(user.achievements, stats, user);
        if (achievements.length === 0) return;
        //save achievements
        for (let i = 0; i < achievements.length; i++) {
            let achievement = achievements[i];
            let points = achievement.points;
            let item = achievement.item;
            //award achievement
            user.achievements.push(achievement.name);
            //award coins
            if (points)
                user.coins = (Number(user.coins) || 0) + Number(points);
            //award item
            if (item) {
                if (!user.items.includes(item)) {
                    user.items.push(item);
                }
            }
        }

        if (this.onNewAchievement) {
            //console.log('{"event":"achievement","value":' + JSON.stringify(achievements) + '}');
            this.onNewAchievement(achievements);
        }
        return achievements;
    }
    checkForAchievement(currentAchievements, stats) {
        var newAchievements = [];
        for (var i = 0; i < this.allAchievements.length; i++) {
            var achievement = this.allAchievements[i];

            //check if user already has achievement
            if (currentAchievements) {
                var alreadyHasAchievement = (currentAchievements.indexOf(achievement.name) !== -1);
                if (alreadyHasAchievement === true) continue;
            }

            //check if any achievements have been achieved
            if (achievement.check !== undefined) {
                let pass = achievement.check(stats || {});
                if (pass === true)
                    newAchievements.push(achievement);
            }
        }

        return newAchievements;
    }

    getAchievement(name) {
        let achievements = this.allAchievements;
        for (let i = 0; i < achievements.length; i++) {
            var achievement = achievements[i];
            if (achievement.name === name) return achievement;
        }
    }
}
